module.exports = __webpack_public_path__ + "assets/img_x.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/img_x.png
 ** module id = 14
 ** module chunks = 1
 **/